import Switch from '@webclient/components/switch';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { setVoiceAutoplayByUserId } from '@webclient/state/slices/app-settings';
import { selectVoice } from '@webclient/state/slices/app-settings/userSettingSelector';

export default function Autoplay() {
  const dispatch = useAppDispatch();
  const voice = useAppSelector(selectVoice);
  const me = useAppSelector((state) => state.auth.me);
  function handleToggle(
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) {
    if (!me) return;
    dispatch(
      setVoiceAutoplayByUserId({
        userId: me.uuid,
        autoplay: checked,
      }),
    );
  }

  return (
    <Switch
      checked={voice.autoplay}
      onChange={handleToggle}
    />
  );
}
